import { HiChevronDown } from "react-icons/hi2";
import SpecialButton from "@/components/specialButton/SpecialButton";
import styles from "./Hero.module.css";
import heroContent from "@/content/home/heroContent";

function Hero() {
    // Scroll To bottom function
    function handleClick() {
        const screenHeight = window.innerHeight;
        window.scrollTo({
            top: screenHeight,
            behavior: "smooth",
        });
    }

    return (
        <>
            {/* Desktop view */}
            <section
                className={`relative hidden md:flex w-full overflow-hidden h-screen md:h-[750px] 2xl:h-[800px] justify-between bg-primary-color-primary ${styles.Hero}`}
                aria-label="Hero section"
            >
                <div className="flex flex-col items-start justify-center text-white ps-3 xl:ps-28">
                    <h2 className="md:text-2xl lg:text-4xl">
                        {heroContent.title}
                    </h2>
                    <p className="pt-5 md:text-medium lg:text-lg md:w-60 lg:w-72 text-wrap text-gray-color-light">
                        {heroContent.description}
                    </p>
                    <div className="mt-10 ">
                        <SpecialButton>{heroContent.buttonText}</SpecialButton>
                    </div>
                </div>
                <div className="absolute self-end w-1/2 max-w-2xl -translate-x-1/2 left-1/2 lg:w-5/12">
                    <img
                        src="/images/home/hero/teacher.webp"
                        alt={heroContent.imageAlt}
                        className="lg:w-full"
                    />
                </div>

                <button
                    className="absolute p-2 border-2 rounded-xl bottom-14 right-1/2"
                    aria-label="button for scrolling down in the website"
                    onClick={handleClick}
                >
                    <HiChevronDown
                        color="white"
                        size={"25px"}
                        className="font-medium animate-bounce"
                    />
                </button>
            </section>

            {/* Mobile view */}
            <section
                className={`md:hidden overflow-hidden w-full bg-primary-color-primary ${styles.HeroMobile}`}
            >
                <div className="flex flex-col items-center justify-end w-full gap-10 text-white h-[740px] ">
                    <div className="text-center ">
                        <h2 className="text-2xl">{heroContent.title}</h2>
                        <p className="w-64 pt-3 text-base text-wrap text-gray-color-light">
                            {heroContent.description}
                        </p>
                        <div className="mt-6">
                            <SpecialButton>
                                <span className="font-semibold text-text-color-secondary">
                                    {heroContent.buttonText}
                                </span>
                            </SpecialButton>
                        </div>
                    </div>

                    <div className=" bottom-2 w-72">
                        <img
                            src="/images/home/hero/teacher.webp"
                            width={"100%"}
                            alt={heroContent.imageAlt}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}

export default Hero;
